import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-210" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-navy-100 border-l-4 border-l-leaf-500 bg-white p-4 pr-10 text-navy-900 shadow-[0_18px_40px_rgba(11,33,64,0.18)]" aria-live="polite" data-id="element-211" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-navy-700 transition-colors duration-150 ease-out hover:text-navy-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-sun-400" aria-label="Cerrar aviso" data-id="element-212" data-mp="1se3bhgtyaa5j">
            <XIcon className="h-4 w-4" data-id="element-213" data-mp="19p4yn1qv3nlf" />
          </button>
          <div className="flex gap-3" data-id="element-214" data-mp="19nlj5dd15gkp">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-600" aria-hidden="true" data-id="element-215" data-mp="1egempxwriiv7" />
            <div data-id="element-216" data-mp="zs0et8kho47s">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-leaf-700" data-id="element-217" data-mp="zsjxwslvkyne">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-218" data-mp="14qlglcfe2vyc">
                Al completar tu compra recibes el
                <br data-id="element-219" data-mp="qsnasvf4w7ug" />
                <span className="font-bold text-navy-900" data-id="element-220" data-mp="vpng3445t6ki">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-navy-700" data-id="element-221" data-mp="2xejb5e7tul1c">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}